// extracted by mini-css-extract-plugin
export var body = "_3s-1";
export var bodyPadded = "_3s-2";
export var chevron = "_3s-4";
export var chevronOpen = "_3s-5";
export var header = "_3s-0";
export var icon = "_3s-3";